<div *ngIf="config?.title">
  <h2 mat-dialog-title class="pb-0 px-3 d-flex align-items-center">
    <mat-icon class="me-1" [color]="config?.iconColor">{{ config?.icon }}</mat-icon
    ><span>{{ config?.title }}</span>
  </h2>
</div>
<div mat-dialog-content class="pt-3 px-3">
  <h4 class="mb-4">{{ config?.message }}</h4>

  <div *ngIf="dynamicData" class="billing_information">
    @if (dynamicData.orderTypeInfo?.orderName && config?.responseType !== 'MONTHLY_COVERED') {
      <p>
        {{ dynamicData.orderTypeBillingModel === 'PAYASYOUGO' ? 'You are about to create a' : 'Order Type:' }}
        <strong>
          {{ dynamicData.orderTypeInfo?.orderName }}
        </strong>
      </p>
    }

    @if (
      dynamicData.orderTypeInfo?.price &&
      (config?.responseType === 'MONTHLY_NOT_COVERED' || config?.responseType === 'PAYASYOUGO_RECOGNIZED')
    ) {
      <p>
        Your cost : <strong style="color: #3966b6">{{ dynamicData.orderTypeInfo?.price | currency }}</strong>
      </p>
    }

    @if (dynamicData.orderTypeInfo?.planInfo?.planName && config?.responseType !== 'MONTHLY_NOT_COVERED') {
      <p>
        Plan Name:<strong> {{ dynamicData.orderTypeInfo?.planInfo?.planName }}</strong>
      </p>
    }

    @if (dynamicData.orderTypeInfo?.planInfo?.includedVolume) {
      <p>
        Included Orders per month:
        <strong>{{ dynamicData.orderTypeInfo?.planInfo?.includedVolume }}</strong>
      </p>
    }

    @if (dynamicData.orderTypeInfo?.planInfo?.currentUsage) {
      <p>
        Your usage thus far this month:
        @if (
          dynamicData.orderTypeInfo?.planInfo?.currentUsage! >= dynamicData.orderTypeInfo?.planInfo?.includedVolume!
        ) {
          <strong class="text-danger">{{ dynamicData.orderTypeInfo?.planInfo?.currentUsage }}</strong>
        } @else {
          <strong>{{ dynamicData.orderTypeInfo?.planInfo?.currentUsage }}</strong>
        }
      </p>
    }

    @if (
      dynamicData.orderTypeInfo?.planInfo?.excessUsageFee &&
      config?.responseType === 'MONTHLY_USAGE_EXHAUSTED_NO_PAYMENT'
    ) {
      <p>
        Excess usage Fee:
        <strong>{{ dynamicData.orderTypeInfo?.planInfo?.excessUsageFee | currency }}</strong>
      </p>
    }
  </div>

  <div *accessControl="config?.actionMessage?.roles">
    <div *ngIf="config?.actionMessage?.message" class="d-flex gap-1 align-items-center p-1 border-top border-bottom">
      <!-- <mat-icon style="font-size: 22px">info</mat-icon> -->
      <p class="mb-0" [innerHTML]="config?.actionMessage?.message"></p>
    </div>
  </div>
</div>

<div mat-dialog-actions class="ms-auto">
  <ng-container *ngFor="let action of config?.actions">
    <ng-container *ngIf="action.type === 'cancel'; else flatButton">
      <button *accessControl="action.roles" mat-button color="" (click)="onActionClick(action.type)">
        {{ action.displayValue }}
      </button>
    </ng-container>

    <ng-template #flatButton>
      <button *accessControl="action.roles" mat-flat-button color="accent" (click)="onActionClick(action.type)">
        {{ action.displayValue }}
      </button>
    </ng-template>
  </ng-container>
</div>
